import { createAuthClient } from "better-auth/react";
import { withSessionCheckTimeout } from "./session-check";

// #4386: /get-session gives up after 8 s, so a stuck server shows the
// sign-in-again banner (RequireAuth) instead of an endless "Loading...".
export const authClient = createAuthClient({
  fetchOptions: { customFetchImpl: withSessionCheckTimeout() },
});

export const { signIn, signUp, signOut } = authClient;

const realUseSession = authClient.useSession;

/**
 * Dev-only: in `vite dev` (`import.meta.env.DEV`), short-circuit the session to a stub admin so
 * the local app renders past RequireAuth without completing OAuth. Pairs with the X-Dev-Bypass
 * header in lib/api.ts (which authorises the API as the dev admin). BOTH are gated to dev and the
 * server only honours the bypass on a localhost BETTER_AUTH_URL — so this is dead in any prod
 * build. There is no role-simulation query parameter (#2930): the stub session and the API bypass
 * both always resolve as the dev admin.
 */
export const useSession: typeof realUseSession = import.meta.env.DEV
  ? ((() => ({
      data: {
        user: { id: "dev-user", email: "dev@localhost", name: "Dev Admin", image: null, emailVerified: true, createdAt: new Date(), updatedAt: new Date() },
        session: { id: "dev-session", userId: "dev-user", token: "dev", expiresAt: new Date(Date.now() + 864e5), createdAt: new Date(), updatedAt: new Date() },
      },
      isPending: false,
      isRefetching: false,
      error: null,
      refetch: () => {},
    })) as unknown as typeof realUseSession)
  : realUseSession;
